import { render, staticRenderFns } from "./ranking.vue?vue&type=template&id=18470070&scoped=true"
import script from "./ranking.vue?vue&type=script&lang=js"
export * from "./ranking.vue?vue&type=script&lang=js"
import style0 from "./ranking.vue?vue&type=style&index=0&id=18470070&prod&lang=scss&scoped=true"
import style1 from "./ranking.vue?vue&type=style&index=1&id=18470070&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18470070",
  null
  
)

export default component.exports